import { Component} from '@angular/core';

@Component({
  selector: 'ben-something-went-wrong',
  templateUrl: './something-went-wrong.component.html',
  styleUrls: ['./something-went-wrong.component.scss']
})

export class SomethingWentWrongComponent {

  constructor() {

  }
}
